import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Constants } from '../core/enums/constants.enum';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {
  constructor(
    private storageService: StorageService) { }

  public getReturnUrl(): string {
    const redirectUrl = this.storageService.getItem(Constants.RETURN_URL_KEY, 'session');
    return redirectUrl ? redirectUrl.toString() : null;
  }
}
